import { configureStore } from "@reduxjs/toolkit";
import rootReducers from "../Reducers/rootReducers";

export default configureStore({
  reducer: { rootReducers },
});
